import {
    type QueryDocumentSnapshot,
    type CollectionReference,
    type DocumentReference,
    type Firestore,
    collection,
    doc,
} from 'firebase/firestore'

export function docRef<T>(
    db: Firestore,
    path: string,
    ...pathSegments: string[]
): DocumentReference<T> {
    return doc(db, path, ...pathSegments) as DocumentReference<T>
}

export function collectionRef<T>(
    db: Firestore,
    path: string,
    ...pathSegments: string[]
): CollectionReference<T> {
    return collection(db, path, ...pathSegments) as CollectionReference<T>
}

export function fillDoc<T extends { id: string }>(
    doc: QueryDocumentSnapshot<T>,
): T {
    return {
        ...doc.data(),
        id: doc.id,
    } as T
}
